import React from "react";
import Lottie from "react-lottie";

interface LottiePlayerComponentProps {
    animationData: any
}

export const LottiePlayerComponent: React.FC<LottiePlayerComponentProps> = ({animationData}: LottiePlayerComponentProps) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return <Lottie options={defaultOptions}></Lottie>
}